import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import thunk from "redux-thunk"
import reducers from "./reducers"

const userInfo = JSON.parse(window.localStorage.getItem("userInfo")) || {}
const initialState = {
    userReducer: {
        loading: false,
        message: "",
        user: userInfo,
        token: "",
        successStatus: false,
        passwordChange: false,
    },
}
const store = createStore(reducers, initialState, composeWithDevTools(applyMiddleware(thunk)))

export default store
